"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledVerticalNav = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _VerticalNavMixin = require("../../mixins/components/VerticalNavMixin");
var StyledVerticalNav = /*#__PURE__*/_styledComponents.default.nav.withConfig({
  displayName: "StyledVerticalNav",
  componentId: "c11n-8-107-0__sc-ggfx93-0"
})(["", ""], _VerticalNavMixin.VerticalNavMixin);
exports.StyledVerticalNav = StyledVerticalNav;